// extracted by mini-css-extract-plugin
module.exports = {"suggestedproducts":"SuggestedProducts-module--suggestedproducts--xUH8v","title":"SuggestedProducts-module--title--2QKjn"};